import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setTitle } from '../../redux/title/action';
import { Space, Spin } from 'antd';
import { ImageTheme } from '../../components/images';
import barcode from '../../assets/images/exBarcode.png';
import { RenderForm } from '../../components/forms';
import { useGetRegisterList } from './hooks/useGetRegisterList';
import { FORM_BARCODE } from './form';
import { TextSmall } from '../../components/text';
import {
  InfoHeaderStyledContainer,
  RegisterStyledContainer,
} from '../../components/container/styles';
import { barcodeCard } from './styles/styles';

export const Register = () => {
  const { control, getValues, setValue, handleOnEnterBarcode, isLoadingBarcode } =
    useGetRegisterList();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setTitle('ลงทะเบียนรับประกันสินค้า'));
  }, [dispatch]);
  return (
    <RegisterStyledContainer>
      <Spin spinning={isLoadingBarcode}>
        <InfoHeaderStyledContainer>
          <TextSmall
            text={
              <span>
                กรอกรหัส <span style={{ color: '#000' }}>Barcode 9 หลักสุดท้าย</span> ของสินค้า
              </span>
            }
            style={{
              color: '#8c6e19',
            }}
            bold
          />
        </InfoHeaderStyledContainer>
        <Space direction="vertical" align="center" style={{ width: '100%', marginTop: 50 }}>
          <div style={{ textAlign: 'center' }}>
            <TextSmall text="ตัวอย่าง Barcode" bold />
          </div>
          <div style={barcodeCard}>
            <ImageTheme src={barcode} style={{ width: 200 }} />
          </div>
        </Space>
        <div style={{ padding: '40px' }}>
          <RenderForm
            control={control}
            getValues={getValues}
            setValue={setValue}
            forms={FORM_BARCODE({ onEnter: handleOnEnterBarcode })}
          />
        </div>
      </Spin>
    </RegisterStyledContainer>
  );
};
